<template>
  <div>
    <a-page-header style="background: #fff; border: 1px solid rgb(235, 237, 240)" title="短信验证码" />
    <a-card style="margin-top: 16px">
      <div class="sms-body">
        <a-form-model ref="form" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-form-model-item label="环境" prop="environment">
            <a-radio-group v-model="form.environment">
              <a-radio-button v-for="(environment, index) in environments" :key="index" :value="environment.value"> {{ environment.label }} </a-radio-button>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="手机号" prop="phone">
            <a-input v-model="form.phone" />
          </a-form-model-item>
          <a-form-model-item :wrapper-col="{ span: 14, offset: 5 }">
            <a-button type="primary" :loading="loading" @click="onSubmit"> 查询验证码 </a-button>
            <a-button style="margin: 0 10px" @click="resetForm"> 重置 </a-button>
          </a-form-model-item>
          <a-form-model-item label="验证码">
            <a-input-group compact>
              <a-input v-model="smsCode" style="width: 85%" disabled />
              <a-tooltip placement="top">
                <template slot="title">
                  <span>点击复制</span>
                </template>
                <a-button style="width: 15%" icon="copy" @click="onCopy(smsCode)" />
              </a-tooltip>
            </a-input-group>
            <span v-if="expiresAt">到期时间: {{ expiresAt }}</span>
          </a-form-model-item>
        </a-form-model>
      </div>
    </a-card>
  </div>
</template>
<script>
import { querySmsCode } from '@/api/tools/sms_code';
export default {
  data() {
    return {
      loading: false,
      sendLoading: false,
      labelCol: { span: 5 },
      wrapperCol: { span: 13 },
      environments: [
        {
          label: 'QA环境',
          value: 'QA'
        },
        {
          label: '开发环境',
          value: 'DEV'
        },
        {
          label: 'Alpha环境',
          value: 'ALPHA'
        },
        {
          label: 'DEMO环境',
          value: 'DEMO'
        }
      ],
      form: {
        environment: 'QA',
        phone: null
      },
      rules: {
        environment: [{ required: true, message: '请选择环境', trigger: 'blur' }],
        phone: [{ required: true, message: '请填写手机号', trigger: 'blur' }]
      },
      smsCode: null,
      expiresAt: null
    };
  },
  methods: {
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          querySmsCode(this.form).then(res => {
            this.smsCode = res.data.sms_code;
            this.expiresAt = res.data.expires_at;
            this.loading = false;
          });
        }
      });
    },
    resetForm() {
      this.form = {
        environment: 'QA',
        phone: null
      };
      this.expiresAt = null;
      this.smsCode = null;
    },
    onCopy(data) {
      const oInput = document.createElement('input');
      oInput.value = data;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand('Copy'); // 执行浏览器复制命令
      oInput.remove();
      this.$message.success('复制成功');
    }
  }
};
</script>

<style lang="less" scoped>
.sms-body {
  width: 960px;
  margin: 0 auto;
}
</style>
